import React from "react";

const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full h-screen bg-[#893fff] flex justify-center items-center p-20"
    >
      <form
        method="POST"
        action="https://getform.io/f/38f974b5-0d25-4ba8-8f69-6ed07f30adce"
        className="flex flex-col max-h-[600px] max-w-[600px] w-full"
      >
        <div className="pb-0">
          <p className="text-4xl font-bold inline border-b-4 border-pink-300 text-gray-300">
            <br /><br />We would love to hear from you
          </p>
          <p className="text-gray-300 py-4">
            // Submit the form below to get in touch -<br />{" "}
            
          </p>
        </div>
        <input
          className="bg-[#ccd6f6] p-2"
          type="text"
          placeholder="Name"
          name="name"
          required
        />
        <input
          className="my-4 p-2 bg-[#ccd6f6]"
          type="email"
          placeholder="Email"
          name="email"
          required
        />
        <textarea
          className="bg-[#ccd6f6] p-2"
          name="message"
          rows="10"
          placeholder="Message"
          required
        ></textarea>
        <button className="text-white border-2 hover:bg-pink-600 hover:border-pink-600 px-4 py-3 my-5 mx-auto flex items-center">
          Let's Collaborate
        </button>
      </form>
    </div>
  );
};

export default Contact;
